// extracted by mini-css-extract-plugin
var _1 = "Icon__image--wuV8m";
export { _1 as "image" }
